import lazySizes from "lazysizes";